import React from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const IconLlmSearch = React.forwardRef<SVGSVGElement, any>((props, ref) => {
  return (<svg enableBackground="new 0 0 24 24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" className="icon-llm-search" width="1em" height="1em" data-icon="icon-llm-search" aria-hidden="true" {...props} ref={ref}><path clipRule="evenodd" d="m1.8 10c0-4.5 3.7-8.1 8.1-8.1s8.1 3.7 8.1 8.1-3.7 8.1-8.1 8.1c-4.4.1-8.1-3.6-8.1-8.1zm8.2-10c-5.5 0-10 4.5-10 10s4.5 10 10 10c2.4 0 4.7-.9 6.4-2.3l6.3 6.3 1.3-1.3-6.3-6.3c1.4-1.7 2.3-4 2.3-6.4-.1-5.5-4.5-10-10-10z" fill="currentColor" fillRule="evenodd"/></svg>);
});

IconLlmSearch.displayName = 'IconLlmSearch';
